import icon from "../Assets/images/404icon.png";
import { Button } from "../Components/ui/button.jsx";
import { useNavigate } from "react-router-dom";
import React from "react";

export const NotFound = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    console.log("click");
    navigate("/");
  };
  return (
    <div className="relative flex h-screen w-full ">
      <div className="flex w-full h-full items-center justify-center flex-col gap-y-10 p-4">
        <img
          src={icon}
          alt="404"
          className="w-full max-h-[200px] max-w-[200px]"
        />
        <h1 className="font-extrabold text-[80px] font-Roboto max-md:text-[50px]">
          Error 404
        </h1>
        <h1 className="font-bold text-[60px] font-Roboto text-slate-500 max-md:text-[30px] ">
          Pagina no encontrada
        </h1>
        <Button
          className="bg-mariposa text-white text-[40px] p-5 h-[80px] max-md:text-[20px] mt-10"
          onClick={handleClick}
        >
          Volver a la página principal
        </Button>
      </div>
    </div>
  );
};
